import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { PATH } from '../../router/PATH';
import { Button } from '@heroui/react';
export const NotFound: React.FC = () => {
    const navigate = useNavigate();
    const { t } = useTranslation('pages');
    const copy = React.useMemo(
        () => ({
            title: t('notFound.title'),
            subtitle: t('notFound.subtitle'),
            action: t('notFound.action'),
        }),
        [t],
    );

    return (
        <div
            className="flex w-full h-lvh flex-col items-center justify-center gap-2"
            data-testid="not-found-page"
            id="not-found-page"
        >
            <h1>{copy.title}</h1>
            <h2>{copy.subtitle}</h2>
            <Button onClick={() => navigate(PATH.HOME)} size="lg">
                {copy.action}
            </Button>
        </div>
    );
};
